import { PoolConfig } from "./types";

const pools: PoolConfig[] = [];

export default pools;
